import React, {Component} from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import Popup from '../Popup/index';
import CameraOptions from '../CameraOptions/index';
import GeneralOptions from '../GeneralOptions/index';
import SoundOptions from '../SoundOptions/index';

import Registry from '../../../registry/index';

class UserSettings  extends Component{
    constructor(props) {
        super(props);

        this.state = {};
        this.onCancel = this.onCancel.bind(this);
        this.onSuccess = this.onSuccess.bind(this);
    }

    onCancel() {
        if (this.props.onCancel) this.props.onCancel();
    }

    onSuccess() {
        if (this.props.onSuccess) this.props.onSuccess();
    }

    render() {
        let lang = Registry.get('locale');
        let {currentUser} = this.props;

        return (
                <div className="content">
                    <Tabs>
                        <TabList>
                            <Tab>
                                <div className="tab-icon general" />
                                {lang.tab_general}
                            </Tab>
                            <Tab>
                                <div className="tab-icon media" />
                                {lang.tab_media}
                            </Tab>
                            <Tab>
                                <div className="tab-icon sound" />
                                {lang.tab_sound}
                            </Tab>
                        </TabList>

                        <TabPanel>
                            <GeneralOptions 
                                onCancel={() => this.onCancel()}
                                onSuccess={() => this.onSuccess()}
                                currentUser={currentUser}
                            />
                        </TabPanel>
                        <TabPanel>
                            <CameraOptions
                                onCancel={() => this.onCancel()}
                                onSuccess={() => this.onSuccess()}/>
                        </TabPanel>
                        <TabPanel>
                            <SoundOptions
                                onCancel={() => this.onCancel()}
                                onSuccess={() => this.onSuccess()}
                            />
                        </TabPanel>
                    </Tabs>
                </div>
        )
    }
}


export default UserSettings;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/SettingsPopup/UserSettings.js